
import { AnimatedTestimonials } from "../../components/ui/animated-testimonials.";

export function Testimonials() {
  const testimonials = [
    {
      quote:
        "Value Blinds transformed my home with their high-quality blinds. The customization options were fantastic, and the installation was seamless!",
      name: "Jessica Miller",
      designation: "Homeowner in Toronto",
      src: "https://images.unsplash.com/photo-1535713875002-d1d0cf377fde?q=80&w=3560&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
    },
    {
      quote:
        "Excellent service and top-quality blinds! Value Blinds helped me find the perfect fit for my office, and the result was stunning.",
      name: "David Anderson",
      designation: "Business Owner in Vancouver",
      src: "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?q=80&w=3540&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
    },
    {
      quote:
        "The motorized blinds from Value Blinds have been a game-changer! Easy to use and stylish, they add a modern touch to my living room.",
      name: "Sophia Reynolds",
      designation: "Interior Designer in Calgary",
      src: "https://images.unsplash.com/photo-1623582854588-d60de57fa33f?q=80&w=3540&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
    },
    {
      quote:
        "I love the quality and variety of blinds at Value Blinds. The customer service was outstanding, and I highly recommend them!",
      name: "Ryan Carter",
      designation: "Real Estate Agent in Edmonton",
      src: "https://images.unsplash.com/photo-1636041293178-808a6762ab39?q=80&w=3464&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
    },
    {
      quote:
        "Amazing selection and great pricing! Value Blinds helped me find the perfect shades for my large windows, and they look fantastic.",
      name: "Linda Peterson",
      designation: "Condo Owner in Montreal",
      src: "https://images.unsplash.com/photo-1624561172888-ac93c696e10c?q=80&w=2592&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
    },
  ];
  return <AnimatedTestimonials testimonials={testimonials} />;
}
